import EmailLayout, { type EmailLayoutProps } from './EmailLayout';

export default EmailLayout;
export type { EmailLayoutProps };
